<template>
  <div class="main-content">
    <div v-if="isLoading">Loading...</div>
    <div v-else>
      <div v-if="asideList.length && isApiComplete" class="container-fluid">
        <div class="row">
          <div class="col aside-col">
            <license-checker-aside :aside-list="asideList" :set-selected-id="setSelectedId" />
          </div>
          <div class="col">
            <license-checker-table
              v-if="selectedId !== ''"
              :selected-id="selectedId"
              :table-data="tableData"
              :line-items-to-modify="lineItemsToModify"
              :modal-data="modalData"
            />
            <div
              class="text-center"
              v-if="selectedId !== '' && hasLineItemsToModify"
              style="margin-top: 30px;"
            >
              <b-button
                class="fix-issue-btn"
                variant="primary"
                size="lg"
                @click="fixIssues"
                :disabled="fixIssuesButtonText === 'Fixing...'"
              >
                {{ fixIssuesButtonText }}
              </b-button>
            </div>
          </div>
          <div class="col-12">
            <license-checker-cads-details
              v-if="selectedId !== ''"
              :data="tableData.assetComponentList"
            />
          </div>

          <div class="col-6">
              <license-checker-initial-order-details
                v-if="selectedId !== ''"
               :data="initialOrderDetails"
               @setSiblingHeight="setRenewalOrderHeight"
               />
          </div>
          <div class="col-6">
            <license-checker-renewal-order-details
              v-if="selectedId !== ''"
              :data="renewalOrderDetails"
              :height="getRenewalHeight"
              />
          </div>
          <div class="col-12" v-if="orderDetails.length">
            <license-checker-order-details
              v-if="selectedId !== ''"
              :data="orderDetails"
            />
          </div>
          <div class="col-12">
            <license-checker-renewal-chain v-if="selectedId !== ''" :grid="grid" />
          </div>
        </div>
      </div>
      <div v-else-if="isApiComplete" class="container-fluid text-center">
        <h5>No active assets or maintenance program found associated to this serial number. Please verify data in CADS.</h5>
      </div>
    </div>
  </div>
</template>

<script>
import LicenseCheckerAside from './license-checker-aside'
import LicenseCheckerTable from './license-checker-table'
import LicenseCheckerCadsDetails from './license-checker-cads-details'
import LicenseCheckerRenewalChain from './license-checker-renewal-chain'
import LicenseCheckerOrderDetails from './license-checker-order-details'
import LicenseCheckerInitialOrderDetails from './license-checker-inital-order-details'
import LicenseCheckerRenewalOrderDetails from './license-checker-renewal-order-details'

export default {
  name: 'LicenseCheckerHeader',
  components: {
    LicenseCheckerAside,
    LicenseCheckerTable,
    LicenseCheckerCadsDetails,
    LicenseCheckerRenewalChain,
    LicenseCheckerOrderDetails,
    LicenseCheckerInitialOrderDetails,
    LicenseCheckerRenewalOrderDetails
  },
  data () {
    return {
      renewalHeight: 200
    }
  },
  props: {
    isLoading: { type: Boolean, default: false },
    asideList: { type: Array, default: () => ([]) },
    setSelectedId: { type: Function, required: true },
    selectedId: { type: String, default: '' },
    tableData: { type: Object, default: () => ({}) },
    grid: { type: Array, default: () => ([]) },
    lineItemsToModify: { type: Object, default: () => ({}) },
    existingDetails: { type: Object, default: () => ({}) },
    fixIssues: { type: Function, default: () => {} },
    fixIssuesButtonText: { type: String, default: 'Fix all issues' },
    orderDetails: { type: Array, default: () => ([]) },
    modalData: { type: Array, default: () => ([]) },
    isApiComplete: { type: Boolean, default: false },
    initialOrderDetails: { type: Array, default: () => ([]) },
    renewalOrderDetails: { type: Array, default: () => ([]) }
  },
  methods: {
    setRenewalOrderHeight (params) {
      this.$nextTick(() => {
        this.renewalHeight = params
      })
    }
  },
  computed: {
    getRenewalHeight () {
      return this.renewalHeight.toString()
    },
    hasLineItemsToModify () {
      return Object.keys(this.lineItemsToModify).length > 0
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../styles/variables.scss';

.main-content {
  margin-top: 90px;
}

.renewal-chain-container {
  margin-top: 30px;
}

.aside-col {
  flex: 0 0 300px;
  max-width: 300px;
}



</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-body.vue